module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cf_gaseosas_pet_2,25_ccsa.95ea73e3.png";